import React, { useCallback } from 'react';
/**
 * TwitterかGDNのURLを返すだけ
 */
const getURLFor = (saleItem, pageType) => {
    if (pageType === 'twitter') {
        return saleItem.url_for_twitter;
    }
    return saleItem.url_for_gdn;
};
const ASaleItem = ({ saleItem }) => {
    const handleClick = useCallback(() => {
        gtag('event', saleItem.event_action, {
            event_category: saleItem.event_category,
            event_label: saleItem.event_label
        });
    }, [
        saleItem.event_action,
        saleItem.event_category,
        saleItem.event_label
    ]);
    return (React.createElement("div", { className: "card-sale-item" },
        React.createElement("div", null,
            React.createElement("div", { className: "card-sale-item-image" },
                React.createElement("img", { className: "lazyload", "data-src": `./assets/img/sale-item/${saleItem.image_name}?${_CACHEBUSTER}` })),
            React.createElement("div", { className: "card-sale-item-discount-rate" },
                React.createElement("span", null, saleItem.discount_rate),
                "% OFF")),
        React.createElement("a", { className: "card-sale-item-name", target: "_blank", href: getURLFor(saleItem, _PAGE_TYPE), onClick: handleClick },
            React.createElement("span", null, saleItem.name),
            React.createElement("span", null, "\u8CFC\u5165\u306F\u3053\u3061\u3089"))));
};
export default ASaleItem;
